import {
  CreateMCDShipperReq,
  CreateMLTShipperReq,
  CreateMWPShipperReq,
  CreateSalesPlatformReq,
  DeleteSalesPlatformReq,
  GetShipperListV2Req,
  GetShipperNamesReq,
  HasShipperCodeAsPathParams,
  ShipperItem,
  ShipperDropdownItem,
  ShipperType,
  UpdateMCDShipperReq,
  UpdateMFSShipperReq,
  UpdateMLTShipperReq,
  UpdateMWPShipperReq,
  UpdateSalesPlatformReq,
  ShipperMenuCode,
} from '@/services/shipper/types'
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'

// MEMO: 화주사 유형 목록
export const SHIPPER_TYPES = ['M1P', 'MFS', 'MWP', 'MLT', 'MCD', 'MTP'] satisfies ShipperType[]

// LOGISPRD-13004 — 로그인 사용자의 허용 화주(소속 화주 ∪ 멀티화주그룹)만 돌려준다. MUSINSA 소속 MASTER 는 활성 화주 전체.
export const getShipperDropdown = () =>
  request.get<ApiResponseV2<{ items: ShipperDropdownItem[] }>>('/api/v1/master/shippers/dropdown')

// LOGISPRD-8888/8746 — Okta 회원가입(비로그인) 화주/부서 검색.
// Kotlin moms-be `/api/v1/auth/*` (게이트웨이 whitelist).
export const searchSignupShippers = (keyword: string) =>
  request.get<ApiResponseV2<{ items: { shipperCode: string; shipperName: string }[] }>>(
    `/api/v1/auth/shippers`,
    { keyword },
    { noAuth: true },
  )

export const getSignupDepartments = (shipperCode: string) =>
  request.get<ApiResponseV2<{ items: { deptName: string }[] }>>(
    `/api/v1/auth/departments`,
    { shipperCode },
    { noAuth: true },
  )

export const PAGE_SIZE_ON_SHIPPER = 50

// memo: MFS가 추가되고 화주사 관리 페이지가 추가되면서 화주사 조회용으로 새롭게 추가된 api입니다.
// 화주 드롭다운도 같이 부른다 — ma14 목록 조회만 화면코드를 실어 감사 로그에 남긴다(LOGISPRD-16007)
export const getShipperListV2 = (params: ApiPaginationReq<GetShipperListV2Req>, menuCode?: ShipperMenuCode) =>
  request.post<ApiPaginationV2<ShipperItem>, ApiPaginationReq<GetShipperListV2Req>>(
    `/api/v1/get-shippers`,
    params,
    menuCode && menuCodeHeaders(menuCode),
  )

// memo: MFS가 추가되고 화주사 관리 페이지가 추가되면서 화주사 조회용으로 새롭게 추가된 api입니다.
export const getShipperNames = (params: GetShipperNamesReq & { returnScreens?: boolean }) =>
  request.post<ApiResponseV2<{ items: string[] }>, GetShipperNamesReq>(`/api/v1/get-shipper-names`, params)

// 화주사 정보 생성 API들 (MFS는 MOMS에서 생성 불가능)
export const createMWPShipper = (params: CreateMWPShipperReq) => request.post(`/api/v1/create-mwp-shipper`, params)
export const createMLTShipper = (params: CreateMLTShipperReq) => request.post(`/api/v1/create-mlt-shipper`, params)
export const createMCDShipper = (params: CreateMCDShipperReq) => request.post(`/api/v1/create-mcd-shipper`, params)

// 화주사 정보 수정 API들
export const updateMFSShipper = (params: UpdateMFSShipperReq) => request.post(`/api/v1/update-mfs-shipper`, params)
export const updateMLTShipper = (params: UpdateMLTShipperReq) => request.post(`/api/v1/update-mlt-shipper`, params)
export const updateMWPShipper = (params: UpdateMWPShipperReq) => request.post(`/api/v1/update-mwp-shipper`, params)
export const updateMCDShipper = (params: UpdateMCDShipperReq) => request.post(`/api/v1/update-mcd-shipper`, params)

// Sales Platform APIs
export const createSalesPlatform = (params: HasShipperCodeAsPathParams<CreateSalesPlatformReq>) =>
  request.post(`/api/v1/shippers/${params.shipperCode}/create-sales-platform`, params)
export const deleteSalesPlatform = (params: HasShipperCodeAsPathParams<DeleteSalesPlatformReq>) =>
  request.post(`/api/v1/shippers/${params.shipperCode}/delete-sales-platform`, params)
export const updateSalesPlatform = (params: HasShipperCodeAsPathParams<UpdateSalesPlatformReq>) =>
  request.post(`/api/v1/shippers/${params.shipperCode}/update-sales-platform`, params)
